import { InboxPageMobileView } from '../../types/InboxPageMobileView';
import { shouldScrollToRenterProfileStore } from '../../lib/inboxStores';
import { TRIGGER_LOCATION } from '../../constants/clickstreamEvents/globals';
import { emitRenterProfileChatBubbleAboutMeClickEvent } from '../../constants/clickstreamEvents/renterProfile';
import type { ZrmClickstreamUserOrNull } from '../../analytics/types';

type HandleRenterProfileClickArgs = {
  isMobileView: boolean;
  user: ZrmClickstreamUserOrNull;
  listingAlias: string | undefined;
  changeMobileView: (nextView: InboxPageMobileView) => void;
};

export function handleRenterProfileClick({
  isMobileView,
  user,
  listingAlias,
  changeMobileView,
}: HandleRenterProfileClickArgs): void {
  emitRenterProfileChatBubbleAboutMeClickEvent({
    user,
    listing: { listingAlias: listingAlias ?? '' },
    triggerLocation: TRIGGER_LOCATION.IreneInbox,
  });
  if (isMobileView) {
    changeMobileView(InboxPageMobileView.RenterProfile);
  }
  shouldScrollToRenterProfileStore.set(true);
}
